import { CopyAll, VpnKey } from "@mui/icons-material";
import { useGetAllApiKeys } from "../api/apiKeys";
import { toast } from "react-toastify";
import LoadingState from "./Common/LoadingState";
import clsx from "clsx";

const ApiKeys = () => {
    const { data: apiKeys, isLoading } = useGetAllApiKeys();

    const handleCopy = (header: string) => {
        navigator.clipboard.writeText(header);
        toast.success('Copied to clipboard');
    };

    return (
        <div className="bg-backgroundGrey w-full h-full flex flex-col overflow-hidden">
            {/* Header Section */}
            <div className="bg-white border-b border-borderGrey px-8 py-6">
                <div className="flex items-center gap-3 mb-2">
                    <div className="p-2 bg-backgroundBlue rounded-lg">
                        <VpnKey className="text-nanonetsBlue" />
                    </div>
                    <div>
                        <h1 className="text-2xl font-semibold text-greyishBlueMid">API Keys</h1>
                        <p className="text-sm text-greyishBlue mt-1">
                            Manage your API keys for authentication
                        </p>
                    </div>
                </div>
            </div>

            {/* Content Section */}
            <div className="flex-1 overflow-auto px-8 py-6">
                {isLoading ? (
                    <div className="flex items-center justify-center h-full">
                        <LoadingState />
                    </div>
                ) : (
                    <>
                        {apiKeys?.length && Array.isArray(apiKeys) ? (
                            <div className="space-y-3">
                                {apiKeys.map(apiKey => {
                                    const header = `Basic ${btoa(`${apiKey.id}:`)}`;
                                    return (
                                        <div
                                            key={apiKey.id}
                                            className="bg-white rounded-lg border border-borderGrey p-4 
                                                       hover:border-nanonetsBlue/30 hover:shadow-md
                                                       transition-all duration-200 cursor-pointer group"
                                            onClick={() => handleCopy(header)}
                                        >
                                            <div className="flex items-center justify-between">
                                                <div className="flex-1 min-w-0">
                                                    <div className="text-xs text-greyishBlue mb-1 font-medium">API Key</div>
                                                    <div className="font-mono text-sm text-greyishBlueMid break-all">
                                                        {header}
                                                    </div>
                                                </div>
                                                <div className="ml-4 p-2 rounded-lg bg-backgroundBlueLight 
                                                               group-hover:bg-backgroundBlue transition-colors">
                                                    <CopyAll className="text-nanonetsBlue" />
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                            <div className="flex flex-col items-center justify-center h-full min-h-[400px]">
                                <div className="p-6 bg-backgroundBlue rounded-full mb-4">
                                    <VpnKey className="text-nanonetsBlue text-4xl" />
                                </div>
                                <h3 className="text-lg font-semibold text-greyishBlueMid mb-2">No API keys found</h3>
                                <p className="text-sm text-greyishBlue text-center max-w-md">
                                    You don't have any API keys yet. API keys will appear here once created.
                                </p>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default ApiKeys;